define('responsive-gameday-loginiframe/responsive-gameday-loginiframe',['require','./src/js/GamedayLoginIframe'],function(require) {
    return require('./src/js/GamedayLoginIframe');
});

